import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/code/portofolio-front/node_modules/@mui/icons-material/esm/Home.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/code/portofolio-front/node_modules/@mui/material/esm/Button/Button.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/code/portofolio-front/node_modules/@mui/material/esm/IconButton/IconButton.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/code/portofolio-front/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/code/portofolio-front/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/code/portofolio-front/src/app/frameworks/page.module.css");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/code/portofolio-front/src/components/LabelPerProjects.module.css");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/code/portofolio-front/src/components/TimingBar.module.css");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/code/portofolio-front/src/components/StatusBadgeJobTitle.module.css");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/code/portofolio-front/src/components/Breadcrumb.module.css");
